var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0DC1BCE8-E601-4183-88E2-F62756FEC079") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-245.000000, -1065.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "policies",
    transform: "translate(245.000000, 1065.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,2.5 L3,5 L13,5 L13,2.5 L14,2.5 C15.1045695,2.5 16,3.3954305 16,4.5 L16,19.5 C16,20.6045695 15.1045695,21.5 14,21.5 L2,21.5 C0.8954305,21.5 -6.3044299e-16,20.6045695 -7.6571374e-16,19.5 L1.5277136e-16,4.5 C1.75006094e-17,3.3954305 0.8954305,2.5 2,2.5 L3,2.5 Z M6,12 L6,13 L13,13 L13,12 L6,12 Z M6,9 L6,10 L13,10 L13,9 L6,9 Z M3,9 L3,10 L5,10 L5,9 L3,9 Z M3,12 L3,13 L5,13 L5,12 L3,12 Z M3,15 L3,16 L5,16 L5,15 L3,15 Z M6,15 L6,16 L11,16 L11,15 L6,15 Z M6,1 C6,0.44771525 6.44771525,1.01453063e-16 7,0 L9,0 C9.55228475,-1.01453063e-16 10,0.44771525 10,1 L11,1 C11.5522847,1 12,1.44771525 12,2 L12,4 L4,4 L4,2 C4,1.44771525 4.44771525,1 5,1 L6,1 Z",
    id: "Combined-Shape",
    fill: "#262728"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.d9c7458424aa1b089d9a52bfefdcc0fb.svg";
export { ForwardRef as ReactComponent };